import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import ArrowDownCircleIcon from 'mdi-react/ArrowDownCircleIcon';
import ArrowUpCircleIcon from 'mdi-react/ArrowUpCircleIcon';
import { colors } from '@prisjakt/ui-base';
import { PeakIndex as TPeakIndex } from '../../../../types';
import * as S from './styles';

const PeakIndex = ({
  title,
  date,
  priceChangeDiscounted: priceChange,
  category,
}: TPeakIndex) => {
  const { t } = useContext(AppContext);
  const priceChangePercent = (priceChange * 100).toFixed(1);
  const description = t('campaigns', 'peak-index.description', {
    campaign: title,
    year: new Date(date).getFullYear(),
    category: category && category.name ? category.name : '',
  });
  if (isNaN(priceChange) || description === 'peak-index.description') {
    return null;
  }
  return (
    <S.PeakIndex>
      <S.Icon>
        <S.MegaphoneIconDesktop />
        <S.MegaphoneIconMobile />
      </S.Icon>
      <S.Description>{description}</S.Description>
      <S.PriceChange>
        {priceChange < 0 ? (
          <ArrowDownCircleIcon size={32} color={colors.green1} />
        ) : (
          <ArrowUpCircleIcon size={32} color={colors.red1} />
        )}
        {`${priceChangePercent}%`}
      </S.PriceChange>
    </S.PeakIndex>
  );
};

export default PeakIndex;
